"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositMethodIssue = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var image_1 = __importDefault(require("next/image"));
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var DepositMethodIssue_module_scss_1 = __importDefault(require("./DepositMethodIssue.module.scss"));
var common_hooks_1 = require("@l2p/common-hooks");
var DepositMethodIssue = function (_a) {
    var onClose = _a.onClose;
    var t = (0, next_intl_1.useTranslations)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var liveChatVisibility = (0, common_hooks_1.useLiveChatVisibility)();
    var _b = (0, common_hooks_1.usePremiumSupport)(), manager = _b.manager, openManager = _b.openManager;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", padding: "0", id: "deposit-modal-failed", overflowY: !(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? 'auto' : 'initial', showClose: !(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile), style: { touchAction: 'none', pointerEvents: 'auto' }, onClose: onClose },
        react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.container },
            (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? (react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.closeButton },
                react_1.default.createElement(ui_components_1.CloseIcon, { onClickHandler: onClose }))) : null,
            react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.content },
                react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.title }, t('deposit-issue.title')),
                react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.issueContainer },
                    react_1.default.createElement(image_1.default, { src: '/img/depositStatuses/deposit-issue.svg', width: 100, height: 100, alt: "deposit-failed" }),
                    react_1.default.createElement("span", { className: DepositMethodIssue_module_scss_1.default.issue }, t('deposit-issue.issue')),
                    react_1.default.createElement("span", { className: DepositMethodIssue_module_scss_1.default.description }, t('deposit-issue.description'))),
                react_1.default.createElement("span", { style: {
                        width: '100%',
                    } },
                    react_1.default.createElement(ui_components_1.FixedButton, { maxWidth: "320px", width: "100%", color: "gradient", text: "upper", onClick: onClose }, t('deposit-issue.buttonText'))),
                react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.support },
                    react_1.default.createElement("div", { className: DepositMethodIssue_module_scss_1.default.supportButton, onClick: function () {
                            if (manager) {
                                openManager();
                                return;
                            }
                            liveChatVisibility();
                        } },
                        react_1.default.createElement("img", { src: "/img/icons/support.svg", alt: "support" }),
                        react_1.default.createElement("span", null, t('translation.support'))))))));
};
exports.DepositMethodIssue = DepositMethodIssue;
